var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.77 138.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4,.cls-6{mix-blend-mode:screen;}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:#99570e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5788.77,
    y1: 1231.98,
    x2: -5637.68,
    y2: 1231.98,
    gradientTransform: "translate(4500.53 3870.33) rotate(52.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6c440f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ffeb65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d87f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ffd66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da9528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5713.22,
    y1: 1276.35,
    x2: -5713.22,
    y2: 1236.73,
    gradientTransform: "translate(1302.56 5790.04) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeb74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd86c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5788.77,
    y1: 1244.93,
    x2: -5637.68,
    y2: 1244.93,
    gradientTransform: "translate(4500.53 3870.33) rotate(52.82)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -5713.22,
    y1: 1271.18,
    x2: -5713.22,
    y2: 1237.22,
    gradientTransform: "translate(1302.56 5790.04) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc74e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff984d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -5770.36,
    y1: 1258.13,
    x2: -5656.09,
    y2: 1258.13,
    gradientTransform: "translate(4500.53 3870.33) rotate(52.82)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.88,49.72C58.66,16.48,31.39-5.28,23,1.12L2.5,16.64,93.81,137l20.46-15.52C122.7,115.09,109.09,83,83.88,49.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 48.15,
    cy: 76.82,
    rx: 19.16,
    ry: 75.54,
    transform: "translate(-36.64 44.72) rotate(-37.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.76,65.74c25.05,33,38.79,64.83,30.88,71.38a1,1,0,0,0,.17-.12c8.43-6.39-5.17-38.52-30.39-71.76s-52.49-55-60.92-48.6l-.16.13C10.78,10.92,37.71,32.72,62.76,65.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 48.15,
    cy: 76.82,
    rx: 14.5,
    ry: 57.16,
    transform: "translate(-36.64 44.72) rotate(-37.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14,31.05c-5.71,5.41,4.55,29.32,23.31,54s39,41.05,45.75,37c1.52-1.43,1.91-4.17,1.31-7.88-9.44-4.35-24-18-37.81-36.14s-23-35.88-24.61-46.15C18.48,30.34,15.74,30,14,31.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.44,115C75,111.1,60,97.22,45.86,78.56s-23.48-36.86-24.74-47c-3.27-1.37-5.87-1.55-7.51-.3-6.38,4.84,3.91,29.15,23,54.3s39.72,41.62,46.1,36.78C84.35,121.11,84.88,118.56,84.44,115Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin4);
export default __webpack_public_path__ + "static/media/coin4.0316fc1792279663a96881c9fb338a8b.svg";
export { ForwardRef as ReactComponent };